import React from "react";
import * as Mui from "@mui/material";
import * as env from "shared/env";
import { Dialog } from "component/shared/dialog";

interface Props {
	open: boolean;
	onClose: () => void;
	onConfirm: () => void;
}

export const DeleteTaskDialog: React.FC<Props> = ({ open, onClose, onConfirm }) => {
	return (
		<Dialog open={open} onClose={onClose}>
			<Mui.DialogTitle>Delete Task</Mui.DialogTitle>
			<Mui.DialogContent>
				<p>Are you sure you want to delete this task?</p>
			</Mui.DialogContent>
			<Mui.DialogActions>
				<Mui.Button variant="outlined" color={"primary"} onClick={onClose}>
					No
				</Mui.Button>
				<Mui.Button variant="contained" color={"primary"} onClick={onConfirm}>
					Yes
				</Mui.Button>
			</Mui.DialogActions>
		</Dialog>
	);
};
